// removed by extract-text-webpack-plugin
module.exports = {"root":"_uuGWx","rows":"_1twK6","title":"_3MZtx","content":"_3e-IP","accountNumber":"_1PLJf","paymentDetailList":"_1RxLV","bankImage":"_2iH3S","hint":"_3piRU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PaymentHandler/THBankTransfer/THBankTransfer.scss
// module id = 1536
// module chunks = 1